import styled from '@emotion/styled'
import { Typography, Card as MuiCard, IconButton } from '@mui/material'
import { typography, colors } from '@resiliatech/birdsong'

export const Card = styled(MuiCard)`
  display: flex;
  flex-direction: column;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  position: relative;
  background-color: white;
  transition: box-shadow 0.2s ease-in-out;
  height: fit-content;
  min-height: 120px;
  width: 100%;
  margin: 0;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

    .goal-comment-actions {
      visibility: visible;
    }
  }
`

export const TopHalf = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
`

export const Details = styled.div`
  display: grid;
  grid-template-columns: 35px auto;
  grid-template-rows: auto auto;
`

export const UserName = styled.div`
  ${typography.down2.regularSans}
  grid-area: 1 / 2;
  font-weight: 500;
`

export const DateInfo = styled.div`
  ${typography.down2.regularSans}
  color: ${colors.text.secondary};
  margin-top: 4px;
  font-size: 12px;
`

export const AssociatedTask = styled.div`
  ${typography.down2.regularSans}
  letter-spacing: 0.5px;
  text-transform: uppercase;
  grid-area: 1/2;
  color: ${colors.text.secondary};
  margin-top: 4px;
`

export const Avatar = styled.div`
  align-items: center;
  display: flex;
  grid-row: span 2;
  margin-right: 8px;
`

export const Actions = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`

export const MenuButton = styled(IconButton)`
  padding: 4px;
`

export const Description = styled(Typography)`
  ${typography.baseline.regularSans}
  overflow-wrap: break-word;
  color: ${colors.text.primary};
  margin-top: 8px;
  min-height: 24px;
  line-height: 1.5;
  display: block;
  flex-grow: 1;
`

export const MediaContainer = styled.div`
  margin-top: 12px;
  width: 100%;
`

export const Image = styled.img`
  width: 100%;
  height: auto;
  border-radius: 4px;
  object-fit: cover;
`
